//*Package imports
import React, { useEffect } from "react";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { setInitialized, logoutUser } from "./store/features/app/appSlice";
//*UI component imports
import Login from "./components/pages/login/Login";
import NotFoundPage from "./components/pages/404/NotFound";
import ResetPassword from "./components/pages/resetPassword/ResetPassword";
import Settings from "./components/pages/settings/Settings";
import Resources from "./components/pages/resources/Resources";
import Chat from "./components/pages/chat/Chat";
import Patients, {
  patientDetailLoader,
} from "./components/pages/patient/Patients";
import SelectClinic from "./components/pages/dashboard/SelectClinic";
import DashboardHome from "./components/pages/dashboard/DashboardHome";
import PatientDashboard from "./components/pages/patient/PatientDashboard";
import Profile from "./components/pages/settings/Profile";
import ChangePassword from "./components/pages/settings/ChangePassword";
import DefaultAssessment from "./components/pages/settings/DefaultAssessment";
import QuickHelp from "./components/pages/resources/QuickHelp";
import HelpfulMaterials from "./components/pages/resources/HelpfulMaterials";
import FAQ from "./components/pages/resources/FAQ";
import AgoraRTM from "agora-rtm-sdk";
import { RtmRole } from "agora-access-token";
import { getPrivilegeExipryRTM } from "./util/helpers";
import { getToken } from "./components/pages/chat/AgoraMethods";
import NewPassword from "./components/pages/resetPassword/NewPassword";
import CareGiver from "./components/pages/caregiver/caregiver";
import LandingPage from "./components/pages/caregiver/LandingPage";
import VideoCallComponent from "./components/pages/telehealth/VideoCallComponent";
import BillingDashboard from "./components/pages/billing/BillingDashboard";
import ACOExecutiveDashboard from "./components/pages/aco/ACOExecutiveDashboard";
import CareMembers from "./components/pages/aco/CareMembers";
import BillingReport from "./components/pages/billing/BillingReport/BillingReport";
import Home from "./components/pages/ops/Home";
import AllClinics from "./components/pages/ops/AllClinics/AllClinics";
import SingleClinic from "./components/pages/ops/SingleClinic";
import ClassEnrollments from "./components/pages/ops/ClassEnollmentsTable/ClassEnrollments";
import Clinicians from "./components/pages/ops/CliniciansTable/Clinicians";
import PatientsList from "./components/pages/ops/PatientsTable/PatientsList";
import OverdueInvoices from "./components/pages/ops/OverdueInvoices/OverdueInvoices";
import PatientMeasure from "./components/pages/aco/PatientMeasure";
import ProfilePDF from "./components/pages/patient/PatientComponents/ProfilePDF";
import Utilization from "./components/pages/ops/Utilization/Utilizations";
import Revenue from "./components/pages/ops/Revenue/Revenue";
import moment from "moment-timezone";
import Applink from "./components/pages/applink/Applink";
import OtpVerify from "./components/common/otp/OtpVerify";
import { toast } from "react-toastify";
import {
  setupInactivityTimeout,
  getRefreshTokenExpiry,
  getServerTime,
} from "./sessionManager";
import DeleteAccount from "./components/pages/delete-account/DeleteAccount";
import AnalyticsPage from "./components/pages/analytics/AnalyticsPage";

moment.tz.setDefault();
// moment.tz.setDefault("America/Denver"); //MST
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    errorElement: <NotFoundPage />,
  },
  {
    path: "/verifyOtp",
    element: <OtpVerify />,
    errorElement: <NotFoundPage />,
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "/verifyOtp",
    element: <OtpVerify />,
  },
  {
    path: "reset",
    element: <ResetPassword />,
  },
  {
    path: "resetPassword/confirm",
    element: <NewPassword />,
  },
  {
    path: "delete-account",
    element: <DeleteAccount />,
  },
  {
    path: "caregiver",
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "assessments",
        element: <CareGiver />,
      },
    ],
  },
  {
    path: "caregiver-landing", // Add this path
    element: <Navigate to="/caregiver/" />, // Redirect to "caregiver"
  },
  {
    path: "telehealth",
    children: [
      {
        index: true,
        element: <VideoCallComponent />,
      },
    ],
  },
  {
    path: "billing",
    children: [
      {
        index: true,
        element: <BillingDashboard />,
      },
      {
        path: "reports/:patientid/:date",
        element: <BillingReport />,
      },
    ],
  },
  {
    path: "aco",
    children: [
      {
        path: "home",
        element: <ACOExecutiveDashboard />,
      },
      {
        index: true,
        element: <ACOExecutiveDashboard />,
      },
      {
        path: "members",
        element: <CareMembers />,
      },
      {
        path: "patient/:type",
        element: <PatientMeasure />,
      },
    ],
  },
  {
    path: "ops",
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "clinics/:type",
        element: <AllClinics />,
      },
      {
        path: "clinic/:clinicID",
        element: <SingleClinic />,
      },
      {
        path: "class-enrollments",
        element: <ClassEnrollments />,
      },
      {
        path: "reports/clinicians",
        element: <Clinicians />,
      },
      {
        path: "reports/patients/",
        element: <PatientsList />,
      },
      {
        path: "reports/utilization/",
        element: <Utilization />,
      },
      {
        path: "reports/revenue/",
        element: <Revenue />,
      },
      {
        path: "reports/overdue-invoices/",
        element: <OverdueInvoices />,
      },
    ],
  },
  {
    path: "dashboard",
    children: [
      {
        index: true,
        element: <SelectClinic />,
      },

      {
        path: "select-clinic",
        element: <SelectClinic />,
      },
      {
        path: "home",
        element: <DashboardHome />,
      },
    ],
  },
  {
    path: "settings",
    element: <Settings />,
    children: [
      {
        index: true,
        element: <Profile />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "",
        element: <ChangePassword />,
      },
      {
        path: "change-password",
        element: <ChangePassword />,
      },
      {
        path: "default-assessment",
        element: <DefaultAssessment />,
      },
      {
        path: "quick-help",
        element: <QuickHelp />,
      },
      {
        path: "help",
        element: <HelpfulMaterials />,
      },
      {
        path: "faq",
        element: <FAQ />,
      },
    ],
  },
  {
    path: "resources",
    element: <Resources />,
    children: [
      {
        index: true,
        element: <FAQ />,
      },
      {
        path: "faq",
        element: <FAQ />,
      },
      {
        path: "quick-help",
        element: <QuickHelp />,
      },
      {
        path: "helpful-materials",
        element: <HelpfulMaterials />,
      },
    ],
  },
  {
    path: "patients",
    element: <Patients />,
    children: [
      {
        path: "all",
        element: <Patients />,
      },
      {
        path: ":patientid",
        loader: patientDetailLoader,
        element: <PatientDashboard />,
      },
    ],
  },
  {
    path: "analytics",
    element: <AnalyticsPage />,
  },
  {
    path: "chat",
    element: <Chat />,
  },
  {
    path: "appstorelink",
    element: <Applink />,
    action: () => {
      // const userAgent = window.navigator.userAgent.toLowerCase();
      const userAgent = "iphone";
      //console.log("userAgent: " , userAgent)
      if (userAgent.includes("android")) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.adolrose";
      } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        window.location.href =
          "https://apps.apple.com/us/app/rose-youth/id1596079012";
      } else {
        // Handle other platforms or fallback behavior
      }
    },
  },
]);

function App() {
  //*Chat Initialization stuff
  const client = React.useMemo(() => {
    const rawAgoraId = process.env.REACT_APP_AGORA_ID;
    const cleanAgoraId = rawAgoraId
      ? rawAgoraId.trim().replace(/^["']|["']$/g, "")
      : "";
    const inst = AgoraRTM.createInstance(cleanAgoraId);
    window.agora = inst;
    return inst;
  }, []);
  const { isInitialized, user } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  //Session time out for inactivity (2 hours / 120 minutes)
  useEffect(() => {
    const accessToken = localStorage.getItem("access");
    if (!accessToken) return; // Only set up timer when user is logged in

    const logout = () => {
      dispatch(logoutUser());
      if (window.persistor) {
        window.persistor.purge();
      }
      localStorage.clear();
      window.location.href = "/login?reason=session_expired";
    };

    const cleanup = setupInactivityTimeout(logout, 60 * 60 * 1000);
    return cleanup;
  }, [user]);

  // Absolute session timeout (12 hours)
  useEffect(() => {
    const accessToken = localStorage.getItem("access");
    if (!accessToken) return;

    let warningTimer;
    let logoutTimer;

    const checkAbsoluteTimeout = () => {
      const expiry = getRefreshTokenExpiry();
      if (!expiry) return;

      const timeLeft = expiry - getServerTime();

      if (timeLeft <= 0) {
        // Already expired
        dispatch(logoutUser());
        if (window.persistor) {
          window.persistor.purge();
        }
        localStorage.clear();
        window.location.href = "/login?reason=absolute_timeout";
        return;
      }

      // 15 minutes in ms = 900,000 ms
      const warningTime = timeLeft - 15 * 60 * 1000;

      if (warningTime > 0) {
        warningTimer = setTimeout(() => {
          toast.warn(
            "Your session will expire in 15 minutes. Please save your work and log in again to renew your session.",
            {
              autoClose: false,
              toastId: "session-warning-toast",
            },
          );
        }, warningTime);
      } else {
        // Less than 15 minutes left, show warning immediately
        toast.warn(
          `Your session will expire in ${Math.round(
            timeLeft / 60000,
          )} minutes. Please save your work and log in again to renew your session.`,
          {
            autoClose: false,
            toastId: "session-warning-toast",
          },
        );
      }

      logoutTimer = setTimeout(() => {
        dispatch(logoutUser());
        if (window.persistor) {
          window.persistor.purge();
        }
        localStorage.clear();
        window.location.href = "/login?reason=absolute_timeout";
      }, timeLeft);
    };

    checkAbsoluteTimeout();

    return () => {
      clearTimeout(warningTimer);
      clearTimeout(logoutTimer);
    };
  }, [user]);

  useEffect(() => {
    const connect = async (uid) => {
      try {
        // If already logging in, connected, or kicked off by remote session, don't start another login process
        if (client._remoteKilled || client._loggingIn || client._logined)
          return;
        client._loggingIn = true;

        const role = RtmRole.Rtm_User;
        const privilegeExpriyTime = getPrivilegeExipryRTM();

        const rawAgoraId = process.env.REACT_APP_AGORA_ID;
        const cleanAgoraId = rawAgoraId
          ? rawAgoraId.trim().replace(/^["']|["']$/g, "")
          : "";
        const rawAgoraCert = process.env.REACT_APP_AGORA_CERTIFICATE;
        const cleanAgoraCert = rawAgoraCert
          ? rawAgoraCert.trim().replace(/^["']|["']$/g, "")
          : "";

        // Safe debugging (logs lengths, not actual keys)
        console.log("RTM connection initiation:", {
          agoraIdLength: cleanAgoraId?.length || 0,
          agoraCertLength: cleanAgoraCert?.length || 0,
          uid: uid,
        });

        const token = getToken(
          cleanAgoraId,
          cleanAgoraCert,
          uid,
          role,
          privilegeExpriyTime,
        );

        console.log("Generated token length:", token?.length || 0);

        await client.login({ uid, token: token });
        window.agora = client;
        client._logined = true; // Simple flag to track login status
        client._loggingIn = false;
      } catch (e) {
        client._loggingIn = false;
        client._logined = false;
        console.log("Agora Login error in App.js", e);
      }
    };

    client.reconnect = async () => {
      console.log("RTM reconnect manual trigger called");
      try {
        await client.logout();
      } catch (e) {
        console.log(
          "Agora RTM logout error during manual reconnect (expected):",
          e,
        );
      } finally {
        client._remoteKilled = false;
        client._logined = false;
        client._loggingIn = false;
        if (user?.role?.includes("CLINIC")) {
          const uid = user?.id.toString();
          connect(uid);
        }
      }
    };

    if (user?.role.includes("CLINIC")) {
      const uid = user?.id.toString();
      connect(uid);
    } else {
      // User is logged out or role changed, cleanly disconnect and reset RTM flags!
      const disconnect = async () => {
        try {
          if (client._logined) {
            await client.logout();
          }
        } catch (e) {
          console.log("Error during Agora RTM logout on user cleanup", e);
        } finally {
          client._logined = false;
          client._loggingIn = false;
          client._remoteKilled = false;
          window.agora = null;
        }
      };
      disconnect();
    }

    const handleConnectionStateChanged = (newState, reason) => {
      console.log(`Agora connection: ${newState}, reason: ${reason}`);
      if (newState === "CONNECTED") {
        client._logined = true;
        client._loggingIn = false;
      }
      if (newState === "DISCONNECTED" || newState === "ABORTED") {
        client._logined = false;
        client._loggingIn = false;
        if (user?.role.includes("CLINIC")) {
          if (reason === "REMOTE_LOGIN") {
            client._remoteKilled = true;
            return;
          }

          // Reconnect logic
          const uid = user?.id.toString();
          setTimeout(() => {
            if (user?.id) connect(uid);
          }, 3000);
        }
      }
    };

    client.on("ConnectionStateChanged", handleConnectionStateChanged);

    return () => {
      client.off("ConnectionStateChanged", handleConnectionStateChanged);
    };
  }, [user, client]); // client is stable now due to useMemo
  // console.log("version:checkpoint - stable - 28-11-2024");
  useEffect(() => {
    if (!isInitialized) {
      dispatch(setInitialized());
    }
  }, [isInitialized]);
  return <RouterProvider router={router} />;
}

export default App;
